// Object type in which the keys consist of the values from the given array
type QueryParamData<T extends Array<string>, V> = {
  [key in T extends Array<infer U> ? U : never]: V;
};

const selectQueryParameters = <T extends Array<string>, V = string>(
  searchString: string,
  params: T,
): QueryParamData<T, V> => {
  const searchParams = new URLSearchParams(searchString);

  return params.reduce(
    (map, key) => {
      if (!searchParams.has(key)) {
        return map;
      }

      return {
        ...map,
        [key]: searchParams.get(key),
      };
    },
    {} as QueryParamData<T, V>,
  );
};

export default selectQueryParameters;
